import React, { Fragment, ReactElement } from 'react';
import Table from '../../../components/table/table.component';
import TableHead from '../../../components/table-head/table-head.component';
import TableBody from '../../../components/table-body/table-body.component';
import TableRow from '../../../components/table-row/table-row.component';
import TableCell from '../../../components/table-cell/table-cell.component';
import ExpansionGroup from '../../../components/expansion-group/expansion-group.component';

const DealInvestmentMetrics: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEditMode,
    isNewDeal,
    dealBuildingDetailsData,
  } = props;

  const isEmpty: boolean = dealBuildingDetailsData && dealBuildingDetailsData.investmentMetrics
  && dealBuildingDetailsData.investmentMetrics.length
    ? !dealBuildingDetailsData.investmentMetrics.reduce((
      isEmptyResult: boolean, dealInvestmentMetricsItem: DealInvestmentMetricsItem,
    ): boolean => (
      isEmptyResult || (!!dealInvestmentMetricsItem.debtYieldValue || !!dealInvestmentMetricsItem.ltcPercent
        || !!dealInvestmentMetricsItem.ltcPercent)
    ), false) : true;

  return (
    <Fragment>
      {
        !isEmpty && dealBuildingDetailsData && dealBuildingDetailsData.investmentMetrics
        && !!dealBuildingDetailsData.investmentMetrics.length && !isEditMode && !isNewDeal && (
          <ExpansionGroup isExpanded isFixed headerComponent="Capitalization Metrics">
            <Table>
              <TableHead isSubHeader>
                <TableRow>
                  <TableCell isText>
                    Group
                  </TableCell>
                  <TableCell isNumber>
                    % / LTV
                  </TableCell>
                  <TableCell isNumber>
                    % / LTC
                  </TableCell>
                  <TableCell isNumber>
                    Debt Yield
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody isPlain withZebraRows withHeaderColumn>
                {
                  dealBuildingDetailsData.investmentMetrics && dealBuildingDetailsData.investmentMetrics.map((
                    dealInvestmentMetricItem: DealInvestmentMetricsItem,
                  ): ReactElement => (
                    <TableRow key={dealInvestmentMetricItem.id}>
                      <TableCell>
                        {dealInvestmentMetricItem.name}
                      </TableCell>
                      <TableCell isNumber>
                        {dealInvestmentMetricItem.ltvPercent || '-'}
                      </TableCell>
                      <TableCell isNumber>
                        {dealInvestmentMetricItem.ltcPercent || '-'}
                      </TableCell>
                      <TableCell isNumber>
                        {dealInvestmentMetricItem.debtYieldValue || '-'}
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </ExpansionGroup>
        )
      }
    </Fragment>
  );
});

export default DealInvestmentMetrics;
